import { AccessRight } from '../enums/access.right.enum';
import { AppRight } from '../enums/app.right.enum';

export class Group {
    id: string;
    name: string;
    accessRight: AccessRight;
    appRight: AppRight;
   constructor() {
   }
}



// WEBPACK FOOTER //
// ./src/app/models/group.model.ts